/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

import { Badge } from '../../../pages/TasksPage/Badge/Badge';
import { TaskMessageLoadingIndicator } from './TaskMessageLoadingIndicator';
import { TaskMessagePrimaryHeading } from './TaskMessagePrimaryHeading';
import { TaskMessageSecondaryHeading } from './TaskMessageSecondaryHeading';
import { Message } from './messageTypes';

export interface TaskMessageSimpleProps {
  message: Message;
  loading?: boolean;
}

export const MessageSimple: React.FC<TaskMessageSimpleProps> = ({ message, loading }) => {
  if (loading) {
    return <TaskMessageLoadingIndicator />;
  }

  if (message.type === 'simple') {
    if (message.headingType === 'primaryHeading') {
      return <TaskMessagePrimaryHeading display={message.display} />;
    }
    if (message.headingType === 'secondaryHeading') {
      return <TaskMessageSecondaryHeading display={message.display} />;
    }
  }

  if (message.type === 'image' && message.image) {
    return <Badge imageName={message.image} altText={message.display} />;
  }

  return null;
};
